{
  "CxiLicenceType_SOLO": "Solo",
  "CxiLicenceType_TEAMS": "Ploegen",
  "CxiLicenceType_UNITE": "Verenigen",
  "CxiLicenceType_NONE": "Geen",
  "NAME": "CxiLicenceTypes"
}